import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pushWorkyMarketingAnalyticsEvent } from './pushWorkyMarketingAnalyticsEvent';
import { TAG_DICTIONARY } from './TagDictionary';

const WorkyAnalyticsRouteListener = (): null => {
  const location = useLocation();

  useEffect((): void => {
    const pagePathFull: string = `${location.pathname}${location.search}`;
    const pageLoc: string =
      typeof window !== 'undefined' ? window.location.href : pagePathFull;

    pushWorkyMarketingAnalyticsEvent({
      event: TAG_DICTIONARY.EVENTS.PAGE_VIEW,
      page_path: pagePathFull,
      page_location: pageLoc,
      page_title:
        typeof document !== 'undefined' &&
        typeof document.title === 'string' &&
        document.title.length > 0
          ? document.title
          : pagePathFull,
    });
  }, [location.pathname, location.search]);

  return null;
};

export { WorkyAnalyticsRouteListener };
